import { render } from "./EducationalAlerts.vue?vue&type=template&id=74b98d06&scoped=true"
import script from "./EducationalAlerts.vue?vue&type=script&lang=js"
export * from "./EducationalAlerts.vue?vue&type=script&lang=js"

import "./EducationalAlerts.vue?vue&type=style&index=0&id=74b98d06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b98d06"]])

export default __exports__